<template>
  <div class="container">
    <!-- <tabBar class="head"></tabBar> -->
    <div class="main clearfix">
      <div class="title">{{ isEdit ? "修改" : "上传" }}作品</div>
      <div class="select_file">
        <p class="text">选择{{ isEdit ? "替换" : "" }}文件</p>
        <div class="fileBox" :style="isEdit ? '' : 'margin-top: 50px;'">
          <p v-if="isEdit" class="editText">当前文件</p>
          <p
            class="tip"
            :class="songUrlError ? 'tip_error' : ''"
            :style="songFileName ? 'color:rgba(38,33,33,1)' : ''"
          >
            {{ songFileName || "请选择要上传的音频文件" }}
          </p>
        </div>

        <el-upload
          class="upload-demo"
          drag
          action="123"
          :auto-upload="false"
          :http-request="uploadFile"
          :on-change="handleChange"
          :show-file-list="false"
        >
          <div class="icon" v-if="!uploadClose && songFileName == null"></div>
          <!-- :show-file-list="false" -->
          <div class="progress" v-if="uploadClose">
            <el-progress
              :width="60"
              type="circle"
              class="content"
              :percentage="loading"
            ></el-progress>
            <p>上传中...</p>
          </div>
          <div class="uploadComplete" v-if="songFileName">
            <div class="complete_img"></div>
            {{ isEdit ? "选择替换文件" : "点击替换" }}
          </div>
        </el-upload>
      </div>
      <div class="perfect_info">
        <div class="perfect_text">
          {{ isEdit ? "修改歌曲信息" : "完善歌曲信息" }}
        </div>
        <div class="song_name_box">
          <div class="song_name">歌曲名称</div>
          <div class="input_box" :class="songNameError ? 'input_error' : ''">
            <el-input placeholder="请输入歌曲名称" v-model="songName" clearable>
            </el-input>
          </div>
        </div>
        <div class="genre_box clearfix">
          <div class="genre_name">
            {{ isEdit ? "修改" : "" }}曲风
            <span
              >可多选<span v-if="genre.length"
                >（已选{{ genre.length }}种曲风）</span
              ></span
            >
          </div>
          <div class="seleted" :class="genreError ? 'input_error' : ''">
            <el-select
              v-model="genre"
              filterable
              clearable
              multiple
              placeholder="请输入或选择曲风"
            >
              <el-option
                v-for="(item, index) in genreOption"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <p class="label_text">热门标签:</p>
          <div class="label_box clearfix">
            <div
              class="labels"
              v-for="(item, index) in hotGenreOption"
              :key="index"
              @click="addTab(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="song_type">
          <div class="song_type_name">歌曲类型</div>
          <div class="seleted_type clearfix">
            <div class="old clearfix" @click="isMyproduct = false">
              <div
                class="old_icon"
                :class="isMyproduct ? 'mine_p' : 'not_mine_p'"
              ></div>
              <p>翻唱</p>
            </div>
            <div class="new clearfix" @click="isMyproduct = true">
              <div
                class="new_icon"
                :class="isMyproduct ? 'mine_p' : 'not_mine_p'"
              ></div>
              <p>原创</p>
            </div>
          </div>
          <el-collapse-transition>
            <div
              class="song_name_input"
              :class="authorError ? 'input_error' : ''"
              v-show="!isMyproduct"
            >
              <el-input
                placeholder="请输入原唱音乐人"
                v-model="author"
                clearable
              >
              </el-input>
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <div class="btns clearfix">
        <div class="updata" @click="updataSong">
          {{ isEdit ? "提交修改" : "上传作品" }}
        </div>
        <div class="cancel" @click="$router.go(-1)">
          取消
        </div>
      </div>
    </div>
    <div class="wx_dialog">
      <el-dialog :visible.sync="wxDialog" width="364px" @close="close">
        <div class="content">
          <div class="img_box">
            <img :src="codeImg" alt="" width="100%" height="100%" />
          </div>
          <div class="code_text">
            亲，您的作品已经{{
              isEdit ? "修改" : "上传"
            }}成功啦，打开微信扫码试听一下吧~
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
var json = require("../../assets/json/allGenre.json");
import axios from "axios";
import { addSong, songDetails, editSong } from "../../api/index";
import tabBar from "../components/tabBar";
export default {
  components: { tabBar },
  data() {
    return {
      codeImg: "",
      wxDialog: false,
      songName: "",
      genreOption: [],
      hotGenreOption: [],
      fileList: [],
      genre: [],
      formData: "",
      // 是否是原创
      isMyproduct: false,
      loading: 0,
      uploadClose: false,
      songFileName: null,
      author: "",
      songUrl: "",
      songDuration: "",
      userInfo: {},
      fileInfo: {},
      //错误
      songUrlError: false,
      songNameError: false,
      genreError: false,
      authorError: false,
      //是否是编辑
      isEdit: false,
      songId: ""
    };
  },
  created() {
    this.genreOption = json.allGenre;
    this.hotGenreOption = json.allGenre;
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    this.$route.query.songId ? (this.isEdit = true) : (this.isEdit = false);
    if (this.isEdit) {
      this.songId = this.$route.query.songId;
      this.editEvent();
    }
  },
  watch: {
    genre(newVal, oldVal) {
      this.hotGenreOption = json.allGenre;
      newVal.forEach(item => {
        this.hotGenreOption = this.hotGenreOption.filter(v => {
          return v.name !== item;
        });
      });
    }
  },
  mounted() {},
  methods: {
    // 关闭弹出层
    close() {
      this.$router.push({
        path: "/product"
      });
    },
    //编辑事件
    async editEvent() {
      let res = await songDetails({ songId: this.$route.query.songId });
      let data = res.data.data;
      console.log(data);

      this.songName = data.songName;
      this.genre =
        data.tag == "" || data.tag == null ? [] : data.tag.split(" ");
      let str = data.songUrl.substr(data.songUrl.lastIndexOf("."));
      this.songFileName = data.songName + str;
      this.songUrl = data.songUrl;
      this.songDuration = data.songDuration;
      if (data.author == "原创") {
        this.isMyproduct = true;
      } else {
        this.author = data.author;
      }
    },
    error() {
      if (this.songUrl == "" || this.songUrl == null) {
        this.songUrlError = true;
      }
      if (this.songName == "" || this.songName == null) {
        this.songNameError = true;
      }
      if (this.genre == "" || this.genre == []) {
        this.genreError = true;
      }
      if (!this.isMyproduct) {
        if (this.author == "" || this.author == null) {
          this.authorError = true;
        }
      }
    },
    // 上传音乐
    async updataSong() {
      this.error();
      if (this.songUrl == "" || this.songUrl == null) {
        this.$message({
          type: "error",
          message: "请先上传文件"
        });
        return;
      }
      if (this.songName == "" || this.songName == null) {
        this.$message({
          type: "error",
          message: "请输入歌曲名称"
        });
        return;
      }
      if (this.genre == "" || this.genre == []) {
        this.$message({
          type: "error",
          message: "请选择曲风"
        });
        return;
      }
      if (!this.isMyproduct) {
        if (this.author == "" || this.author == null) {
          this.authorError = true;
          this.$message({
            type: "error",
            message: "请输入原唱音乐人"
          });
          return;
        }
      }
      this.$openLoading();
      let data = {
        songExtId: new Date().getTime() + "",
        songName: this.songName,
        songUrl: this.songUrl,
        songDuration: this.songDuration,
        songSnapshot: "string",
        chorusStart: 30,
        chorusEnd: 60,
        author: this.isMyproduct
          ? "原创"
          : this.author == ""
          ? "原创"
          : this.author,
        tag: this.genre.join(" ")
      };
      if (this.isEdit) {
        this.$closeLoading();
        data.songId = this.songId;
        let res = await editSong(data);
        if (res.data.code == 200) {
          this.$closeLoading();
          this.codeImg = res.data.data.previewUrl;
          this.$message({
            type: "success",
            message: "作品上传成功"
          });
          this.wxDialog = true;
        } else {
          this.$closeLoading();
          this.$message({
            type: "error",
            message: res.data.message
          });
        }
      } else {
        let res = await addSong(data);
        if (res.data.code == 200) {
          this.$closeLoading();
          this.codeImg = res.data.data.previewUrl;
          this.$message({
            type: "success",
            message: "作品上传成功"
          });
          this.wxDialog = true;
        } else {
          this.$closeLoading();
          this.$message({
            type: "error",
            message: res.data.message
          });
        }
      }
    },
    addTab(val) {
      this.genre.push(val.name);
    },

    handleChange(file, fileList) {
      let name = file.name.substr(file.name.lastIndexOf("."));

      if (
        name == ".m4a" ||
        name == ".mp3" ||
        name == ".aac" ||
        name == ".flac" ||
        name == ".ogg" ||
        name == ".ape" ||
        name == ".wma" ||
        name == ".amr"
      ) {
        if (file.size / 1024 / 1024 > 7) {
          this.$message({
            type: "error",
            message: "请上传的音频不要超过10MB"
          });
          return;
        }
        let strLength = file.name.length - name.length;
        this.songName = file.name.substring(0, strLength);
        this.fileList = [file];
        this.songFileName = file.name;
        this.getTimes(this.fileList[0].raw);
        this.submitUpload();
      } else {
        this.$message({
          type: "error",
          message: "请上传正确的音频文件格式"
        });
      }
    },
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    getTimes(file) {
      var content = file;
      var url = URL.createObjectURL(content);
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", _event => {
        this.songDuration = parseInt(audioElement.duration);
      });
    },

    submitUpload() {
      let that = this;
      that.uploadClose = true;
      let formData = new FormData();
      formData.append("theme", that.theme);
      formData.append("file", that.fileList[0].raw);
      axios({
        url: "https://api.singschool.cn/api/upload/file",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data;charset=utf-8"
        },
        onUploadProgress: function(evt) {
          if (evt.lengthComputable) {
            that.loading = Math.round((evt.loaded / evt.total) * 100);
          }
        }
      })
        .then(res => {
          if (res.data.success) {
            that.songUrl = res.data.data;
            that.uploadClose = false;
            that.loading = 0;
            that.$message({
              type: "success",
              message: "文件上传成功"
            });
          } else {
            that.$message({
              type: "error",
              message: "文件上传失败"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.wx_dialog {
  .content {
    width: 364px;
    height: 360px;
    background-color: #fff;
    overflow: hidden;
    border-radius: 7px;
    .img_box {
      width: 212px;
      height: 212px;
      margin: 54px auto 0;
    }
    .code_text {
      width: 190px;
      margin: 0 auto;
      text-align: center;
      font-size: 14px;
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(128, 124, 124, 1);
    }
  }
}
.wx_dialog /deep/ .el-dialog__header {
  padding: 0;
  height: 0;
}
.wx_dialog /deep/ .el-dialog {
  background-color: transparent;
  border-radius: 8px;
}

.wx_dialog /deep/.el-dialog__body {
  padding: 0;
  background-color: transparent;
  border-radius: 8px;
}
.input_error /deep/ .el-input__inner {
  &::placeholder {
    color: rgba(255, 64, 64, 1);
  }
  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: rgba(255, 64, 64, 1);
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: rgba(255, 64, 64, 1);
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: rgba(255, 64, 64, 1);
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: rgba(255, 64, 64, 1);
  }
}
.input_edit /deep/ .el-input__inner {
  &::placeholder {
    color: rgba(128, 124, 124, 1);
  }
  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: rgba(128, 124, 124, 1);
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: rgba(128, 124, 124, 1);
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: rgba(128, 124, 124, 1);
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: rgba(128, 124, 124, 1);
  }
}
.container {
  width: 100%;
  background: rgba(250, 250, 250, 1);
  padding-top: 80px;
  .main {
    width: 1027px;
    min-height: 100vh;
    margin: 0 auto;
    .title {
      margin-top: 16px;
      width: 100%;
      height: 68px;
      background: rgba(254, 255, 254, 1);
      border-radius: 10px;
      font-size: 28px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      color: rgba(38, 33, 33, 1);
      line-height: 68px;
      padding-left: 40px;
      margin-bottom: 8px;
    }
    .select_file {
      height: 200px;
      background: rgba(254, 255, 254, 1);
      border-radius: 10px;
      padding: 20px 40px;
      .text {
        font-size: 20px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: rgba(38, 33, 33, 1);
      }
      .fileBox {
        float: left;
        margin-top: 40px;
        .editText {
          margin-bottom: 12px;
        }
      }
      .tip {
        float: left;
        font-size: 16px;
        font-family: SourceHanSansCN-Normal;
        font-weight: 400;
        color: rgba(179, 175, 175, 1);
        margin-right: 84px;
      }
      .tip_error {
        color: rgba(255, 64, 64, 1);
      }
      .upload-demo {
        width: 120px;
        height: 120px;
        background: rgba(254, 255, 254, 1);
        box-shadow: 0px 0px 30px 0px rgba(42, 35, 35, 0.1);
        border-radius: 15px;
        float: left;
        .icon {
          width: 44px;
          height: 44px;
          background: url("../../assets/jlt_pc.png") no-repeat;
          background-size: 535px 314px;
          background-position: -409px -197px;
          margin: 38px auto;
        }
      }
    }
    .select_file /deep/ .el-upload {
      width: 120px;
      height: 120px;
      overflow: hidden;
    }
    .select_file /deep/ .el-upload-dragger {
      width: 120px;
      height: 120px;
      border: none;
    }
    .perfect_info {
      width: 100%;
      background: rgba(254, 255, 254, 1);
      min-height: 566px;
      border-radius: 10px;
      margin-top: 8px;
      padding: 20px 40px;
      .perfect_text {
        width: 120px;
        height: 20px;
        font-size: 20px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: rgba(38, 33, 33, 1);
        line-height: 30px;
      }
      .song_name_box {
        margin-top: 32px;
        .song_name {
          font-size: 16px;
          font-family: SourceHanSansCN-Normal;
          font-weight: 400;
          color: rgba(38, 33, 33, 1);
          margin-bottom: 16px;
        }
        .input_box {
          width: 567px;
        }
      }
      .genre_box {
        margin-top: 28px;
        .genre_name {
          font-size: 16px;
          font-family: SourceHanSansCN-Normal;
          font-weight: 400;
          color: rgba(38, 33, 33, 1);
          line-height: 24px;
          span {
            font-size: 14px;
            font-family: SourceHanSansCN-Normal;
            font-weight: 400;
            color: rgba(128, 124, 124, 1);
            line-height: 21px;
            padding-left: 8px;
          }
        }
        .seleted {
          width: 567px;
          margin-top: 16px;
        }
        .label_text {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal;
          font-weight: 400;
          color: rgba(179, 175, 175, 1);
          line-height: 20px;
          margin: 12px 0;
        }
        .label_box {
          width: 567px;
          height: 108px;
          overflow: hidden;
          .labels {
            height: 28px;
            background: rgba(240, 240, 240, 1);
            border-radius: 8px;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal;
            font-weight: 400;
            color: rgba(179, 175, 175, 1);
            line-height: 28px;
            float: left;
            padding: 0 12px;
            margin-right: 12px;
            margin-bottom: 8px;
            cursor: pointer;
          }
        }
      }
      .song_type {
        margin-top: 21px;
        .song_type_name {
          font-size: 16px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: rgba(38, 33, 33, 1);
          line-height: 24px;
        }
        .seleted_type {
          margin-top: 20px;
          margin-bottom: 17px;
          .old {
            cursor: pointer;
            width: 70px;
            float: left;
            .old_icon {
              width: 28px;
              height: 28px;
              background: url("../../assets/jlt_pc.png") no-repeat;
              background-size: 535px 314px;
              background-position: -209px -97px;
              float: left;
            }
            .mine_p {
              background: url("../../assets/jlt_pc.png") no-repeat;
              background-size: 535px 314px;
              background-position: -251px -97px;
            }
            .not_mine_p {
              background: url("../../assets/jlt_pc.png") no-repeat;
              background-size: 535px 314px;
              background-position: -209px -97px;
            }
            p {
              line-height: 28px;
              padding-left: 13px;
              font-size: 16px;
              font-family: SourceHanSansCN-Normal;
              font-weight: 400;
              color: rgba(38, 33, 33, 1);
            }
          }
          .new {
            cursor: pointer;
            float: left;
            margin-left: 20px;
            width: 60px;
            .new_icon {
              width: 28px;
              height: 28px;
              background: url("../../assets/jlt_pc.png") no-repeat;
              background-size: 535px 314px;
              background-position: -251px -97px;
              float: left;
            }
            .mine_p {
              background: url("../../assets/jlt_pc.png") no-repeat;
              background-size: 535px 314px;
              background-position: -209px -97px;
            }
            .not_mine_p {
              background: url("../../assets/jlt_pc.png") no-repeat;
              background-size: 535px 314px;
              background-position: -251px -97px;
            }
            p {
              line-height: 28px;
              padding-left: 13px;
              font-size: 16px;
              font-family: SourceHanSansCN-Normal;
              font-weight: 400;
              color: rgba(38, 33, 33, 1);
            }
          }
        }
        .song_name_input {
          width: 567px;
        }
      }
    }
    .btns {
      margin-top: 16px;
      margin-bottom: 100px;
      .updata {
        width: 160px;
        height: 40px;
        cursor: pointer;
        background: linear-gradient(
          137deg,
          rgba(255, 83, 132, 1) 0%,
          rgba(255, 39, 39, 1) 100%
        );
        text-align: center;
        border-radius: 10px;
        font-size: 20px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 40px;
        float: left;
      }
      .cancel {
        cursor: pointer;
        width: 160px;
        height: 40px;
        border-radius: 12px;
        border: 1px solid rgba(204, 204, 204, 1);
        float: left;
        margin-left: 20px;
        font-size: 20px;
        font-family: SourceHanSansCN-Normal;
        font-weight: 400;
        color: rgba(179, 175, 175, 1);
        line-height: 40px;
        text-align: center;
      }
    }
  }
}
.progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 120px;
  font-size: 14px;
  margin-top: 20px;
  font-family: SourceHanSansCN-Normal;
  font-weight: 400;
  color: rgba(179, 175, 175, 1);
  z-index: 999;
  background: rgba(254, 255, 254, 1);
  text-align: center;
  .content {
    margin: 0 auto;
  }
}
.uploadComplete {
  width: 120px;
  height: 120px;
  background: rgba(254, 255, 254, 1);
  box-shadow: 0px 0px 30px 0px rgba(42, 35, 35, 0.1);
  border-radius: 15px;
  position: absolute;
  top: 0;
  color: rgba(179, 175, 175, 1);
  .complete_img {
    width: 41px;
    height: 46px;
    background: url("../../assets/jlt_pc.png") no-repeat;
    background-size: 535px 314px;
    background-position: -335px -195px;
    margin: 26px auto 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/update/update.vue